
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

// Lazy load components
const HomePage = lazy(() => import('../pages/home/page'));
const OSHAConsultingPage = lazy(() => import('../pages/osha-consulting/page'));
const OSHATrainingPage = lazy(() => import('../pages/osha-training/page'));
const SafetyStaffingPage = lazy(() => import('../pages/safety-staffing/page'));
const IndustrialHygienePage = lazy(() => import('../pages/industrial-hygiene/page'));
const CoatingInspectionPage = lazy(() => import('../pages/coating-inspection/page'));
const CoreValuesPage = lazy(() => import('../pages/core-values/page'));
const MeetTeamPage = lazy(() => import('../pages/meet-team/page'));
const TestimonialsPage = lazy(() => import('../pages/testimonials/page'));
const MissionVisionPage = lazy(() => import('../pages/mission-vision/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const CareersPage = lazy(() => import('../pages/careers/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/osha-consulting',
    element: <OSHAConsultingPage />,
  },
  {
    path: '/osha-training',
    element: <OSHATrainingPage />,
  },
  {
    path: '/safety-staffing',
    element: <SafetyStaffingPage />,
  },
  {
    path: '/industrial-hygiene',
    element: <IndustrialHygienePage />,
  },
  {
    path: '/painting-services',
    element: <CoatingInspectionPage />,
  },
  {
    path: '/coating-inspection',
    element: <CoatingInspectionPage />,
  },
  {
    path: '/core-values',
    element: <CoreValuesPage />,
  },
  {
    path: '/meet-team',
    element: <MeetTeamPage />,
  },
  {
    path: '/testimonials',
    element: <TestimonialsPage />,
  },
  {
    path: '/mission-vision',
    element: <MissionVisionPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/careers',
    element: <CareersPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
